/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MissingPreferredSelectionsReport } from '../models/MissingPreferredSelectionsReport';
import type { SiteSelectionMigrationReport } from '../models/SiteSelectionMigrationReport';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SiteSelectionMigrationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SiteSelectionMigrationReport OK
     * @throws ApiError
     */
    public postApiHousingSiteSelectionMigrationPreviewMigration(): CancelablePromise<SiteSelectionMigrationReport> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteSelectionMigration/PreviewMigration',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns SiteSelectionMigrationReport OK
     * @throws ApiError
     */
    public postApiHousingSiteSelectionMigrationExecuteMigration(): CancelablePromise<SiteSelectionMigrationReport> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteSelectionMigration/ExecuteMigration',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public postApiHousingSiteSelectionMigrationBackfillTotalEligibleSites(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteSelectionMigration/BackfillTotalEligibleSites',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Finds active applications (Waitlist/LockedInterviewing/OnHold) that have 0 Preferred rows
     * in ApplicationSiteSelections but may have recoverable Preferred data in the JSON columns.
     * @returns MissingPreferredSelectionsReport OK
     * @throws ApiError
     */
    public postApiHousingSiteSelectionMigrationPreviewMissingPreferredSelections(): CancelablePromise<MissingPreferredSelectionsReport> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteSelectionMigration/PreviewMissingPreferredSelections',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns MissingPreferredSelectionsReport OK
     * @throws ApiError
     */
    public postApiHousingSiteSelectionMigrationFixMissingPreferredSelections(): CancelablePromise<MissingPreferredSelectionsReport> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteSelectionMigration/FixMissingPreferredSelections',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
